import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  const [getUserType, setUserType] = React.useState("Admin");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();

    let authUser = JSON.parse(localStorage.getItem("authUser"));
    if (authUser != null) {
      setUserType(authUser.Users_Type_ID)
    }

  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menü")} </li>

            <li>
              <Link to="/" >
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Anasayfa")}</span>
              </Link>
            </li>

            <li>
              <Link to="/users" >
                <i className="bx bx-user"></i>
                <span>{props.t("Kullanıcılar")}</span>
              </Link>
            </li>

            <li>
              <Link to="/job-posts" >
                <i className="bx bx-briefcase"></i>
                <span>{props.t("İş İlanları")}</span>
              </Link>
            </li>

            <li>
              <Link to="/companies" >
                <i className="bx bx-buildings"></i>
                <span>{props.t("Şirketler")}</span>
              </Link>
            </li>

            <li>
              <Link to="/community-posts" >
                <i className="bx bx-message-square-detail"></i>
                <span>{props.t("Topluluk Gönderileri")}</span>
              </Link>
            </li>

            <li>
              <Link to="/comments" >
                <i className="bx bx-comment"></i>
                <span>{props.t("Yorumlar")}</span>
              </Link>
            </li>

            <li>
              <Link to="/salary-entries" >
                <i className="bx bx-money"></i>
                <span>{props.t("Maaş Girişleri")}</span>
              </Link>
            </li>

            <li>
              <Link to="/reports" >
                <i className="bx bx-error-circle"></i>
                <span>{props.t("Raporlar")}</span>
              </Link>
            </li>

            <li>
              <Link to="/site-settings" >
                <i className="bx bx-cog"></i>
                <span>{props.t("Site Ayarları")}</span>
              </Link>
            </li>

            <li>
              <Link to="/pages" >
                <i className="bx bx-file"></i>
                <span>{props.t("Sayfalar")}</span>
              </Link>
            </li>

            <li>
              <Link to="/contact-messages" >
                <i className="bx bx-envelope"></i>
                <span>{props.t("İletişim Mesajları")}</span>
              </Link>
            </li>

            <li>
              <Link to="/premium-plans" >
                <i className="bx bx-crown"></i>
                <span>{props.t("Premium Planlar")}</span>
              </Link>
            </li>

            <li>
              <Link to="/payments" >
                <i className="bx bx-credit-card"></i>
                <span>{props.t("Ödemeler")}</span>
              </Link>
            </li>

            <li>
              <Link to="/admin-users" >
                <i className="bx bx-shield"></i>
                <span>{props.t("Admin Kullanıcıları")}</span>
              </Link>
            </li>

            <li>
              <Link to="/professions" >
                <i className="bx bx-briefcase-alt"></i>
                <span>{props.t("Meslekler")}</span>
              </Link>
            </li>

            <li>
              <Link to="/cities" >
                <i className="bx bx-map"></i>
                <span>{props.t("Şehirler")}</span>
              </Link>
            </li>

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
